module.exports = JSON.parse('{"Measurements":"القياسات","Studies":"الدراسات"}')